import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    let data;
    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = text;
    }

    const token = response.headers.get("Authorization");
    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout(); // auto logout if 401 response returned from API
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Helper: Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// -------------------- Room Services --------------------

function getRoomList(searchText = "", roomCategories = []) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const categories = Array.isArray(roomCategories)
    ? roomCategories
    : [roomCategories];
  const categoryQuery = categories
    .filter(Boolean)
    .map((category) =>
      `roomCategories=${encodeURIComponent(category)}`)
    .join("&");
  const url =
    `${basePath}/v1/rooms?facilityId=&roomStatus=` +
    (categoryQuery ? `&${categoryQuery}` : "");

  return apiFetch(url, requestOptions).then((response) => {
    if (!searchText || !Array.isArray(response?.roomList)) return response;

    const term = searchText.toLowerCase();
    return {
      ...response,
      roomList: response.roomList.filter((room) =>
        [room?.roomName, room?.roomCode, room?.description]
          .some((value) => String(value || "").toLowerCase().includes(term))
      ),
    };
  });
}

function addRoom(data) {
  const requestOptions = {
    method: "POST",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/roomAdd`;
  return apiFetch(url, requestOptions);
}

function modifyRoom(data) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/roomChange?id=${data.id}`;
  return apiFetch(url, requestOptions);
}

function roomDelete(data) {
  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(),
    body: JSON.stringify(data),
  };
  const url = `${basePath}/v1/roomDelete?id=${data.id}&status=${data.status}`;
  return apiFetch(url, requestOptions);
}

// -------------------- Luxury Level --------------------
function getLuxuryLevelLists() {
  const requestOptions = { method: "GET", headers: buildHeaders() };
  const url = `${basePath}/v1/luxuryLevelLists`;
  return apiFetch(url, requestOptions);
}

// -------------------- Room Management Details --------------------
function roomManagementDetails() {
  const requestOptions = { method: "GET", headers: buildHeaders() };
  const url = `${basePath}/v1/room/roomManageDetails`;
  return apiFetch(url, requestOptions);
}

function getRoomOccupancy(date, totalDays = 1) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/v1/room/occupancy?date=${encodeURIComponent(date)}&totalDays=${totalDays}`;
  return apiFetch(url, requestOptions);
}



// -------------------- Export --------------------
const roomServices = {
  handleResponse,
  getRoomList,
  addRoom,
  modifyRoom,
  roomDelete,
  getLuxuryLevelLists,
  roomManagementDetails,
  getRoomOccupancy,   // ? new
};

export default roomServices;
